import React from 'react';
import styles from './ServicesDescription.module.css';
import { Trans } from 'react-i18next';

/**
 * Компонент для отображения описания услуг с иконками
 * @param {Array} items - массив объектов с иконками и описанием
 * @param {React.Component} items[].icon - компонент иконки
 * @param {string} items[].description - текст описания
 */
const ServicesDescription = ({ items }) => {
  // Логируем для отладки
  console.log('Отрисовка ServicesDescription с элементами:', items);

  return (
    <section className={styles.sectionDescription}>
        <div className={styles.conteiner}>
            {items.map((item, index) => (
                <div key={index} className={styles.item}>
                    <div className={styles.iconWrapper}>
                        {item.icon}
                    </div>
                    <p className={styles.description}>
                        <Trans
                            i18nKey={item.description}
                            components={{ 
                                warning: <span className={styles.warningInline} />
                            }}
                        />
                    </p>
                </div>
            ))}
        </div>
    </section>
  );
};

export default ServicesDescription; 